import { useEffect } from 'react';

import { useSale } from './useSale';

import { useBranch } from '../branches/useBranch';
import { useAuthUser } from '../auth/useAuthUser';
import { useCustomer } from '../useCustomer';
import { useDocumentType } from '../useDocumentType';

import { useAllowedOptions } from '../settings/useAllowedOptions';

import { DOCUMENT_TYPE_CODES } from '../../constants/documentTypeCodes';

import { getTodayDateString } from '../../utils/dateFormatters';

const usePOSHeader = () => {
  // =====================================================
  // 🔹 Sale
  // =====================================================
  const {
    form,
    formErrors,
    updateField,
    activeDocumentType,

    isSubmitting,

    handlerGenerateSale,
    handlerUpdateSaleHeader,
    handlerResetSaleFormOnly,
  } = useSale();

  // =====================================================
  // 🔹 Data
  // =====================================================
  const {
    fetchSalesBranchDropdown,
    branchDropdown,
    myBranch,
    fetchMyBranch,
  } = useBranch();

  const { hasRole } = useAuthUser();

  // Solo estos roles pueden vender a nombre de otra sucursal; para el resto
  // se toma siempre la propia, sin mostrar el selector.
  const canPickBranch =
    hasRole('ADMIN') || hasRole('SUPPORT') || hasRole('ACCOUNTANT');

  const {
    fetchDocumentTypeDropdown,
    documentTypeDropdown,
  } = useDocumentType();

  const {

    saveCustomer,

    handlerGetCustomersForDropdown,

    customersDropdown,

    openAddModal,

    closeAddModal,

    showRegistrationModal,

  } = useCustomer();

  const {
    getCodes,
    fetchCodesByModuleAndTarget,
  } = useAllowedOptions();

  // =====================================================
  // 🚀 Init
  // =====================================================
  useEffect(() => {
    fetchSalesBranchDropdown();

    fetchDocumentTypeDropdown();

    handlerGetCustomersForDropdown();

    fetchCodesByModuleAndTarget(
      'SALES',
      'DOCUMENT_TYPE'
    );

    fetchMyBranch();
  }, []);

  // =====================================================
  // 🏢 Sucursal por defecto (editable si tiene el rol)
  // =====================================================
  useEffect(() => {
    if (myBranch && !form.branch?.id) {
      updateField('branch', { id: myBranch.id, name: myBranch.name });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myBranch]);

  // =====================================================
  // 📅 Default Date
  // =====================================================
  useEffect(() => {
    if (!form.id && !form.saleDate) {
      updateField(
        'saleDate',
        getTodayDateString()
      );
    }
  }, [
    form.id,
    form.saleDate,
    updateField,
  ]);

  // =====================================================
  // 🔹 Allowed Docs
  // =====================================================
  const allowedCodes = getCodes(
    'SALES',
    'DOCUMENT_TYPE'
  );

  const allowedDocumentTypes =
    documentTypeDropdown.filter((doc) =>
      allowedCodes.includes(doc.code)
    );

  // =====================================================
  // 🔹 Credit Note
  // =====================================================
  const isCreditNote =
    activeDocumentType?.code ===
    DOCUMENT_TYPE_CODES.CREDIT_NOTE;

  // =====================================================
  // ✅ Return
  // =====================================================
  return {
    form,
    formErrors,

    updateField,

    isSubmitting,

    branchDropdown,
    canPickBranch,
    customersDropdown,

    allowedDocumentTypes,

    handlerGenerateSale,
    handlerUpdateSaleHeader,
    handlerResetSaleFormOnly,

    reloadCustomersDropdown:
      handlerGetCustomersForDropdown,

    saveCustomerQuick:
      saveCustomer,

    openCustomerModal:
      openAddModal,

    closeCustomerModal:
      closeAddModal,

    showCustomerModal:
      showRegistrationModal,

    isCreditNote,
  };
};

export default usePOSHeader;